import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.EmergencyMode.title',
    defaultMessage: 'Emergency mode',
  },
  startingEmergencyModeFailed: {
    id: 'app.components.EmergencyMode.startingEmergencyModeFailed',
    defaultMessage: 'Enabling emergency mode failed!',
  },
});
